import { styled } from '@mui/system';
import MuiTypography from '@mui/material/Typography';
import MuiDialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';

export const DeleteTitle = styled(MuiTypography)({
  fontSize: '1.25rem',
  fontWeight: 500,
  lineHeight: 1.6,
  letterSpacing: '0.0075em',
  whiteSpace: 'pre-wrap'
});

export const DialogTitle = styled(MuiDialogTitle)({
  backgroundColor: '#ff4635'
});

export const StyledDialogContentText = styled(DialogContentText)({
  marginTop: '8px'
});
